// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.door-lock-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.door-lock-panel {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  display: flex;
  flex-direction: column;
  max-width: 94vw;
  max-height: 85vh;
  padding: 20px 22px 18px;
}
.door-lock-panel * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .door-lock-panel {
    animation: none;
  }
}

.door-lock-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
  flex-shrink: 0;
}
.door-lock-header-icon {
  display: none;
}
.door-lock-header-title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  flex: 1;
}
.door-lock-header-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
  padding: 5px 10px;
  font-size: 13px;
  font-size: 18px;
  line-height: 1;
  padding: 4px 9px;
}
.door-lock-header-close:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.door-lock-header-close:active:not(:disabled) {
  transform: translateY(1px);
}
.door-lock-header-close:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.door-lock-header-close:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.door-lock-header-close:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}

.door-lock-tabs {
  display: flex;
  gap: 2px;
  margin-bottom: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  flex-shrink: 0;
}

.door-lock-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 12px;
  margin-bottom: -1px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  cursor: pointer;
}
.door-lock-tab:hover {
  color: #ebe8e1;
}
.door-lock-tab:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.door-lock-tab--active, .door-lock-tab--active:hover {
  color: var(--gold-light);
  border-bottom-color: var(--gold-main);
}

.door-lock-body {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-right: 4px;
}
.door-lock-body::-webkit-scrollbar {
  width: 6px;
}
.door-lock-body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.door-lock-divider {
  flex-shrink: 0;
  height: 1px;
  margin: 16px 0 4px;
  background: rgba(255, 255, 255, 0.12);
}

.door-lock-label {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
  margin: 12px 0 6px;
}
.door-lock-label:first-child {
  margin-top: 0;
}

.door-lock-select,
.door-lock-input {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
}
.door-lock-select:focus,
.door-lock-input:focus {
  outline: none;
  border-color: var(--gold-main);
}
.door-lock-select::placeholder,
.door-lock-input::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}

.door-lock-select option {
  background: #171b24;
  color: #ebe8e1;
}

.door-lock-player-list {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
  max-height: 140px;
}
.door-lock-player-list::-webkit-scrollbar {
  width: 6px;
}
.door-lock-player-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.door-lock-player {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  cursor: pointer;
  transition: color 0.12s ease, border-color 0.12s ease;
}
.door-lock-player-bullet {
  width: 8px;
  height: 8px;
  flex: none;
  border: 1px solid #8d8a82;
  border-radius: 50%;
  transition: background-color 0.12s ease, border-color 0.12s ease;
}
.door-lock-player:hover {
  color: #ebe8e1;
  border-color: var(--gold-dark);
}
.door-lock-player:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.door-lock-player--selected {
  color: var(--gold-light);
  border-color: var(--gold-main);
}
.door-lock-player--selected .door-lock-player-bullet {
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.door-lock-player--offline {
  opacity: 0.7;
}

.door-lock-empty {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  padding: 6px 0;
}

.door-lock-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}

.door-lock-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 4px 3px 10px;
  font-size: 13px;
  font-weight: 600;
  color: var(--gold-light);
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid var(--gold-dark);
  border-radius: 6px;
}
.door-lock-chip button {
  padding: 0 6px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 16px;
  line-height: 1.2;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
}
.door-lock-chip button:hover {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.09);
}
.door-lock-chip button:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 1px;
}

.door-lock-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #ebe8e1;
  font-size: 14px;
  font-weight: 600;
  margin-top: 14px;
  cursor: pointer;
  user-select: none;
}
.door-lock-toggle input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.door-lock-toggle-box {
  position: relative;
  width: 18px;
  height: 18px;
  flex: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.35);
  transition: border-color 0.12s ease;
}
.door-lock-toggle:hover .door-lock-toggle-box {
  border-color: var(--gold-dark);
}
input:focus-visible + .door-lock-toggle-box {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
input:checked + .door-lock-toggle-box {
  border-color: var(--gold-main);
}
input:checked + .door-lock-toggle-box::after {
  content: "";
  position: absolute;
  inset: 3px;
  border-radius: 2px;
  background: var(--gold-main);
}

.door-lock-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  flex-shrink: 0;
}

.door-lock-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.door-lock-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.door-lock-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.door-lock-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.door-lock-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.door-lock-btn--ghost {
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
}
.door-lock-btn--ghost:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.door-lock-btn--danger {
  color: #d9786d;
  background: transparent;
  border-color: rgba(217, 120, 109, 0.45);
  margin-right: auto;
}
.door-lock-btn--danger:hover:not(:disabled) {
  background: rgba(217, 120, 109, 0.14);
  border-color: #d9786d;
}
.door-lock-btn--primary {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.door-lock-btn--primary:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/components/DoorLockConfig/DoorLockConfig.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAPA;EACE,eAAA;EACA,QAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AASF;;AANA;EDqBE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;EC/JA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAeF;ADCE;EAAI,sBAAA;ACEN;AD2IE;ECpKF;IDoK4C,eAAA;ECvI1C;AACF;;AApBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;AAuBF;AApBE;EAAS,aAAA;AAuBX;AArBE;EDwBA,kDA3BW;EA4BX,gBAAA;EACA,eCzBqB;ED0BrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ECaH,OAAA;AA4BJ;AAzBE;ED+CA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAyBA,cArGO;EAsGP,uBAAA;EACA,yBAAA;EAMA,iBAAA;EACA,eAAA;EC5FE,eAAA;EACA,cAAA;EACA,gBAAA;AA6CJ;ADaE;EAAyB,qCAAA;EAAuC,8BAAA;ACTlE;ADUE;EAA0B,0BAAA;ACP5B;ADQE;EAAa,YAAA;EAAc,mBAAA;ACJ7B;ADKE;EAAkB,oCAAA;EAAsC,mBAAA;ACD1D;ADyBE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;ACpBhF;;AA5DA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,kDAAA;EACA,cAAA;AA+DF;;AA5DA;EDkIE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,yDAjKU;EAkKV,eAAA;EACA,gBAAA;EACA,cA5KO;EA6KP,uBAAA;EACA,SAAA;EACA,oCAAA;EACA,eAAA;AClEF;ADoEE;EAAU,cAnLL;ACkHP;ADkEE;EAAkB,oCAAA;EAAsC,oBAAA;AC9D1D;AAhFE;EDkJA,wBAAA;EACA,qCAAA;AC/DF;;AAhFA;EDsGE,gBAAA;EACA,qBAAA;EACA,qDAAA;ECtGA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAqFF;ADgBE;EAAuB,UAAA;ACbzB;ADcE;EAA6B,oCAAA;EAAsC,kBAAA;ACVrE;;AAzFA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,qCDxDK;ACoJP;;AAzFA;EDDE,eAAA;EACA,gBAAA;EACA,cAzDO;EC0DP,kBAAA;AA8FF;AA5FE;EAAgB,aAAA;AA+FlB;;AA5FA;;EDoDE,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;AC6CF;AD3CE;;EAAU,aAAA;EAAe,8BAAA;ACgD3B;AD/CE;;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACuD1G;;AAjHA;EACE,mBAAA;EACA,cDvEK;AC2LP;;AAjHA;EDsEE,gBAAA;EACA,qBAAA;EACA,qDAAA;ECtEA,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;AAsHF;ADlDE;EAAuB,UAAA;ACqDzB;ADpDE;EAA6B,oCAAA;EAAsC,kBAAA;ACwDrE;;AA1HA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDD/EU;ECgFV,eAAA;EACA,gBAAA;EACA,cD1FO;EC2FP,qCDhGW;ECiGX,2CAAA;EACA,kBDzFO;EC0FP,eAAA;EACA,qDAAA;AA6HF;AA3HE;EACE,UAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,gEAAA;AA6HJ;AA1HE;EAAU,cD3GL;EC2GuB,8BAAA;AA8H9B;AA7HE;EAAkB,oCAAA;EAAsC,mBAAA;AAiI1D;AA/HE;EACE,wBAAA;EACA,8BAAA;AAiIJ;AA/HI;EACE,4BAAA;EACA,8BAAA;AAiIN;AA7HE;EACE,YAAA;AA+HJ;;AA3HA;ED3EE,eAAA;EACA,gBAAA;EACA,cAlDO;EC6HP,cAAA;AAgIF;;AA7HA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;AAgIF;;AA7HA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,qCDrJW;ECsJX,kCAAA;EACA,kBD9IO;AC8QT;AA9HE;EACE,cAAA;EACA,yDD9IQ;EC+IR,eAAA;EACA,gBAAA;EACA,cDzJK;EC0JL,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AAgIJ;AA9HI;EAAU,cDhKP;ECgKyB,qCAAA;AAkIhC;AAjII;EAAkB,oCAAA;EAAsC,mBAAA;AAqI5D;;AAjIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cDzKK;EC0KL,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAoIF;AAlIE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;AAoIJ;AAjIE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,0CAAA;EACA,kBAAA;EACA,+BDjMQ;ECkMR,mCAAA;AAmIJ;AAhIE;EAAgB,8BAAA;AAmIlB;AAjIE;EAA8B,oCAAA;EAAsC,mBAAA;AAqItE;AAnIE;EACE,8BAAA;AAqIJ;AAnII;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;AAqIN;;AAhIA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,+CAAA;EACA,cAAA;AAmIF;;AAhIA;ED9JE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;ACkSF;ADhSE;EAAyB,qCAAA;EAAuC,8BAAA;ACoSlE;ADnSE;EAA0B,0BAAA;ACsS5B;ADrSE;EAAa,YAAA;EAAc,mBAAA;ACyS7B;ADxSE;EAAkB,oCAAA;EAAsC,mBAAA;AC4S1D;AA/JE;EDzHA,cArGO;EAsGP,uBAAA;EACA,yBAAA;AC2RF;ADzRE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;AC8RhF;AArKE;EDrIA,cA5FO;EA6FP,uBAAA;EACA,uCAAA;ECqIE,kBAAA;AAyKJ;AD5SE;EAAyB,qCAAA;EAAuC,qBAhGzD;ACgZT;AA1KE;EDlJA,cAjFU;EAkFV,4BAAA;EACA,8BAAA;AC+TF;AD7TE;EAAyB,6BAAA;EAA+B,+BAAA;ACiU1D","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n.door-lock-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.door-lock-panel {\n  @include ink.panel;\n  @include ink.enter;\n  display: flex;\n  flex-direction: column;\n  max-width: 94vw;\n  max-height: 85vh;\n  padding: 20px 22px 18px;\n}\n\n.door-lock-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 12px;\n  flex-shrink: 0;\n\n  // Decorative glyph, no longer displayed.\n  &-icon { display: none; }\n\n  &-title {\n    @include ink.title(22px);\n    flex: 1;\n  }\n\n  &-close {\n    @include ink.button;\n    @include ink.button-quiet;\n    @include ink.button-sm;\n    font-size: 18px;\n    line-height: 1;\n    padding: 4px 9px;\n  }\n}\n\n// Underline tabs, as in the housing drawer.\n.door-lock-tabs {\n  display: flex;\n  gap: 2px;\n  margin-bottom: 14px;\n  border-bottom: 1px solid ink.$line;\n  flex-shrink: 0;\n}\n\n.door-lock-tab {\n  @include ink.tab;\n\n  &--active,\n  &--active:hover { @include ink.tab-active; }\n}\n\n.door-lock-body {\n  @include ink.scroll;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding-right: 4px;\n}\n\n.door-lock-divider {\n  flex-shrink: 0;\n  height: 1px;\n  margin: 16px 0 4px;\n  background: ink.$line;\n}\n\n.door-lock-label {\n  @include ink.label;\n  margin: 12px 0 6px;\n\n  &:first-child { margin-top: 0; }\n}\n\n.door-lock-select,\n.door-lock-input {\n  @include ink.field;\n}\n\n.door-lock-select option {\n  background: #171b24;\n  color: ink.$text;\n}\n\n.door-lock-player-list {\n  @include ink.scroll;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 10px;\n  max-height: 140px;\n}\n\n.door-lock-player {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  font-family: ink.$font-text;\n  font-size: 13px;\n  font-weight: 600;\n  color: ink.$text-2;\n  background: ink.$ink-raised;\n  border: 1px solid ink.$line;\n  border-radius: ink.$radius;\n  cursor: pointer;\n  transition: color 0.12s ease, border-color 0.12s ease;\n\n  &-bullet {\n    width: 8px;\n    height: 8px;\n    flex: none;\n    border: 1px solid ink.$text-3;\n    border-radius: 50%;\n    transition: background-color 0.12s ease, border-color 0.12s ease;\n  }\n\n  &:hover { color: ink.$text; border-color: var(--gold-dark); }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n\n  &--selected {\n    color: var(--gold-light);\n    border-color: var(--gold-main);\n\n    .door-lock-player-bullet {\n      background: var(--gold-main);\n      border-color: var(--gold-main);\n    }\n  }\n\n  &--offline {\n    opacity: 0.7;\n  }\n}\n\n.door-lock-empty {\n  @include ink.hint;\n  padding: 6px 0;\n}\n\n.door-lock-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 10px;\n}\n\n.door-lock-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 4px 3px 10px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--gold-light);\n  background: ink.$ink-raised;\n  border: 1px solid var(--gold-dark);\n  border-radius: ink.$radius;\n\n  button {\n    padding: 0 6px;\n    font-family: ink.$font-text;\n    font-size: 16px;\n    line-height: 1.2;\n    color: ink.$text-2;\n    background: transparent;\n    border: 0;\n    border-radius: 4px;\n    cursor: pointer;\n\n    &:hover { color: ink.$text; background: rgba(255, 255, 255, 0.09); }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 1px; }\n  }\n}\n\n.door-lock-toggle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: ink.$text;\n  font-size: 14px;\n  font-weight: 600;\n  margin-top: 14px;\n  cursor: pointer;\n  user-select: none;\n\n  input {\n    position: absolute;\n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n\n  &-box {\n    position: relative;\n    width: 18px;\n    height: 18px;\n    flex: none;\n    border: 1px solid ink.$line-strong;\n    border-radius: 4px;\n    background: ink.$ink-field;\n    transition: border-color 0.12s ease;\n  }\n\n  &:hover &-box { border-color: var(--gold-dark); }\n\n  input:focus-visible + &-box { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n\n  input:checked + &-box {\n    border-color: var(--gold-main);\n\n    &::after {\n      content: '';\n      position: absolute;\n      inset: 3px;\n      border-radius: 2px;\n      background: var(--gold-main);\n    }\n  }\n}\n\n.door-lock-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 16px;\n  padding-top: 14px;\n  border-top: 1px solid ink.$line;\n  flex-shrink: 0;\n}\n\n.door-lock-btn {\n  @include ink.button;\n\n  &--ghost {\n    @include ink.button-quiet;\n  }\n\n  &--danger {\n    @include ink.button-danger;\n    margin-right: auto;\n  }\n\n  &--primary {\n    @include ink.button-primary;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
